import { Injectable, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '../../auth/auth.service';
import { fromEvent, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class DialogSessionManagerService implements OnDestroy {
    private readonly TOKEN_STORAGE_KEY = 'access_token';
    private readonly PRINCIPAL_USER = 'principalUser';
    private storageSubscription: Subscription;
    private currentToken: string | null = null;

    constructor(
        private readonly dialog: MatDialog,
        private readonly authService: AuthService
    ) {}

    initialize(): void {
        this.currentToken = localStorage.getItem(this.TOKEN_STORAGE_KEY);

        this.storageSubscription = fromEvent<StorageEvent>(window, 'storage')
            .pipe(
                filter(event => 
                    event.key === this.TOKEN_STORAGE_KEY || 
                    event.key === this.PRINCIPAL_USER ||
                    event.key === null
                )
            )
            .subscribe((event: StorageEvent) => {
                this.handleStorageChange(event);
            });
    }

    private handleStorageChange(event: StorageEvent): void {
        const newToken = localStorage.getItem(this.TOKEN_STORAGE_KEY);

        if (event.key === null) {
            this.closeAllDialogs();
            return;
        }

        if (event.key === this.TOKEN_STORAGE_KEY) {
            if (!newToken && this.currentToken) {
                this.closeAllDialogs();
                this.currentToken = null;
            } else if (newToken && newToken !== this.currentToken) {
                this.closeAllDialogs();
                this.currentToken = newToken;
            }
        }

        if (event.key === this.PRINCIPAL_USER) {
            if (!event.newValue && event.oldValue) {
                this.closeAllDialogs();
            }
        }
    }

    private closeAllDialogs(): void {
        if (this.dialog.openDialogs && this.dialog.openDialogs.length > 0) {
            this.dialog.closeAll();
        }
    }

    ngOnDestroy(): void {
        if (this.storageSubscription) {
            this.storageSubscription.unsubscribe();
        }
    }
}
